import type { CSSProperties, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { BracketedWrapper } from '@sorare/core/src/atoms/BracketedWrapper/index.tsx';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyL, BrandXL } from '@sorare/core/src/atoms/typography';

const StyledBracketedWrapper = styled(BracketedWrapper)`
  gap: var(--unit);
  padding: var(--unit) var(--double-unit);
`;

type Props = {
  categoryIcon: ReactNode;
  categoryTitle: ReactNode;
};

export const MissionPageHeader = ({ categoryIcon, categoryTitle }: Props) => {
  return (
    <Vertical center gap={1}>
      <StyledBracketedWrapper
        style={{ '--border-color': 'var(--c-white)' } as CSSProperties}
      >
        <span>{categoryIcon}</span>
        <BrandXL>{categoryTitle}</BrandXL>
      </StyledBracketedWrapper>
      <BodyL className="text-center">
        <FormattedMessage defaultMessage="Get rewarded by playing daily" />
      </BodyL>
    </Vertical>
  );
};
